<template>
  <div>
    <b-modal
      v-model="isModalActive"
      :width="480"
      scroll="keep"
      :can-cancel="false"
    >
      <div
        class="card is-flex is-justify-content-space-evenly is-align-items-center"
      >
        <b-button
          type="is-info is-light"
          size="is-large"
          @click="promotionSelected('r')"
        >
          <figure class="image is-64x64">
            <img
              :src="
                (promotingColor || playerColor) === 'black'
                  ? CHESS_SVG.ROOK_BLACK
                  : CHESS_SVG.ROOK_WHITE
              "
            />
          </figure>
        </b-button>

        <b-button
          type="is-info is-light"
          size="is-large"
          @click="promotionSelected('n')"
        >
          <figure class="image is-64x64">
            <img
              :src="
                (promotingColor || playerColor) === 'black'
                  ? CHESS_SVG.KNIGHT_BLACK
                  : CHESS_SVG.KNIGHT_WHITE
              "
            />
          </figure>
        </b-button>

        <b-button
          type="is-info is-light"
          size="is-large"
          @click="promotionSelected('b')"
        >
          <figure class="image is-64x64">
            <img
              :src="
                (promotingColor || playerColor) === 'black'
                  ? CHESS_SVG.BISHOP_BLACK
                  : CHESS_SVG.BISHOP_WHITE
              "
            />
          </figure>
        </b-button>

        <b-button
          type="is-info is-light"
          size="is-large"
          @click="promotionSelected('q')"
        >
          <figure class="image is-64x64">
            <img
              :src="
                (promotingColor || playerColor) === 'black'
                  ? CHESS_SVG.QUEEN_BLACK
                  : CHESS_SVG.QUEEN_WHITE
              "
            />
          </figure>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { EventBus } from "@/services/event-bus";
import { CHESS_SVG } from "@/utils/chess-svg";

export default {
  name: "Promote",

  props: ["playerColor"],

  data() {
    return {
      isModalActive: false,
      orig: null,
      dest: null,
      promoteTo: null,
      promotingColor: null,
      CHESS_SVG,
    };
  },

  methods: {
    showModal(orig, dest, promotingColor) {
      this.orig = orig;
      this.dest = dest;
      this.promoteTo = null;
      
      if (promotingColor) {
        this.promotingColor = promotingColor;
      }
      
      this.isModalActive = true;
    },

    promotionSelected(promoteTo) {
      this.promoteTo = promoteTo;
      this.isModalActive = false;
      this.promotingColor = null;
      this.$emit("onPromotion", this.orig, this.dest, promoteTo);
      EventBus.$emit("onPromotionSelected", this.orig, this.dest, promoteTo);
    },
  },

  mounted() {
    EventBus.$on("onPromotion", this.showModal);
  },

  beforeDestroy() {
    EventBus.$off("onPromotion", this.showModal);
  },
};
</script>

<style></style>
